import { isAfter, isFuture, safeDifferenceInCalendarDays } from 'shared/util/datetime-fns';

export interface CheckInCheckOutErrorTexts {
    missingCheckInDate: string;
    missingCheckOutDate: string;
    invalidCheckInDate: string;
    invalidCheckOutDate: string;
    tooManyDaysBetweenDates: string;
}

export const validateCheckInCheckOut = (
    errorTexts: CheckInCheckOutErrorTexts,
    checkInDate?: Date | number,
    checkOutDate?: Date | number,
): readonly string[] => {
    const validationErrors = {
        missingCheckInDate: !checkInDate ? errorTexts.missingCheckInDate : undefined,
        missingCheckOutDate: !checkOutDate ? errorTexts.missingCheckOutDate : undefined,
        invalidCheckInDate: checkInDate && !isFuture(checkInDate) ? errorTexts.invalidCheckInDate : undefined,
        invalidCheckOutDate: checkInDate && checkOutDate && isAfter(checkOutDate, checkInDate) ? errorTexts.invalidCheckOutDate : undefined,
        tooManyDaysBetweenDates:
            checkInDate && checkOutDate && safeDifferenceInCalendarDays(checkInDate, checkOutDate) > 30
                ? errorTexts.tooManyDaysBetweenDates
                : undefined,
    };
    return Object.values(validationErrors).filter((error) => error);
};
